<template>

    <div class="groups">
        <page-header title="Спиcок групп"/>
        <ol class="groups__list" >
            <li class="list__item" v-for="(group, index) of groups" :key="index">
                {{group.name}}
            </li>
        </ol>
    </div>
</template>

<script>
import {mapMutations} from 'vuex'
import pageHeader from '../components/pageHeader'
export default {
    data() {
        return {
            groups:[]
        }
    },
    components:{
        'page-header':pageHeader
    },
    mounted() {
        this.axios.get(`api/disciplines/${this.$route.params.did}/groups`).then(res=>{
            this.groups = res.data.groups
        })
    },
}
</script>

<style lang="scss">
    .groups{
        height: 100%;
        display: grid;
        grid-template-rows: max-content auto;
        .groups__list{
            overflow-y: auto;
            margin: 0;
            .list__item{
                //list-style: none;
                padding: 10px;
            }
        }
    }
</style>